import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '../shared/dialog/Dialog';
import { Photo } from '../shared/Photo';

export const ReactionHintDialog: React.FC = () => {
  const { t } = useTranslation('reaction');
  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;
          h1 {
            color: #4d3906;
            font-size: 20px;
            text-align: center;
          }
          p {
            margin: 0 0 8px;
          }
          section {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px 0;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .sec-1-img {
            width: 278px;
            height: 180px;
            margin: 24px auto 20px;
            transform: rotate(-2deg);
          }
          .sec-2-img {
            width: 224px;
            height: 145px;
            margin: 20px auto 48px;
            position: relative;
            transform: rotate(2deg) translate(20px, 16px);
          }
          .bf-icon {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 96px;
            height: 96px;
            position: absolute;
            top: -32px;
            left: -52px;
            z-index: 1;
            transform: rotate(-2deg);
            filter: drop-shadow(0px 0px 12px rgba(0, 0, 0, 0.1));
          }
          /* less than iPhone6/7/8 display size */
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 18px;
            }
            .sec-1-img {
              width: 214px;
              height: 140px;
            }
            .sec-2-img {
              width: 172px;
              height: 111px;
              transform: rotate(2deg) translate(16px, 12px);
            }
            .bf-icon {
              width: 72px;
              height: 72px;
              top: -24px;
              left: -36px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <section>
          <div className="sec-1-img">
            <Photo
              srcSet={`
              /images/reaction/img_reaction_hint_01-2x.jpg 2x,
              /images/reaction/img_reaction_hint_01.jpg 1x
              `}
            />
          </div>
          <p>{t('help_desc_01')}</p>
          <p>{t('help_desc_02')}</p>
          <p>{t('help_desc_03')}</p>
        </section>
      </div>
    </Dialog>
  );
};
